import { DeleteRequest, GetRequest, PatchRequest, PutRequest } from "../service"

const ControllerName = "Provider" // This controller for provider registration request

export const GetAllProvider = (link) => {
    return GetRequest(ControllerName + link)
}

export const GetProviderDetails = (id) => {
    return GetRequest(`${ControllerName}/${id}`)
}

export const UpdateProviderData = (id , body) => {
    return PutRequest(`${ControllerName}/${id}`,body)
}

export const DeleteProvider = (DObject) => {
    return DeleteRequest(`${ControllerName}/${DObject?.id}`)
}

export const AcceptProvider = (DObject , body) => {
    return PatchRequest(`${ControllerName}/accept/${DObject?.id}` ,body)
}

export const RejectProvider = (DObject ) => {
    return PatchRequest(`${ControllerName}/reject/${DObject?.id}` ,{note : DObject.note})
}